<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'groupsCrud'"
          crudName="Grupos"
          newText="Novo Grupo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="canCreateGroups"
          :enableEdit="true"
          :enableDelete="canDeleteGroups"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  components: {
    BaseCrud,
  },

  data: function () {
    return {
      table: "groupsTable",
      groupsCrud: {},
      pages: [],
      url: "",
      columns: [
        "group_id",
        "group_nome",
        "company_name",
        "status",
        "actions",
      ],
      tableData: [
        "group_id",
        "group_nome",
        "company_name",
        "status",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["group_id", "group_nome", "company_name", "status"],
        sortable: ["group_id", "group_nome", "company_name", "status"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        orderBy: { column: "group_id", ascending: true },
        headings: {
          group_id: "ID",
          group_nome: "Nome do Grupo",
          company_name: "Empresa",
          status: "Status",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: "1",
              text: "Ativo",
            },
            {
              id: "0",
              text: "Inativo",
            },
          ],
        },
        templates: {
          company_name: function (h, row) {
            return row.company && row.company.name ? row.company.name : "-";
          },
          status: function (h, row) {
            if (row.status === "1" || row.status === 1 || row.status === true) {
              return (
                <h5>
                  <span class="badge badge-primary">Ativo</span>
                </h5>
              );
            } else if (row.status === "0" || row.status === 0 || row.status === false) {
              return (
                <h5>
                  <span class="badge badge-danger">Inativo</span>
                </h5>
              );
            }

            return (
              <h5>
                <span class="badge badge-secondary">Desconhecido</span>
              </h5>
            );
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "groups",
      dataForm: {},
    };
  },

  computed: {
    loggedUser() {
      return this.$store.state.auth?.user || this.$store.state.user || null;
    },

    isUsuarioPadraoLogged() {
      return Number(this.loggedUser?.perfil_id) === 2;
    },

    isGestorOperacionalLogged() {
      return Number(this.loggedUser?.perfil_id) === 7;
    },

    // Gestor Operacional pode ver e editar grupos, mas não criar nem excluir
    canCreateGroups() {
      return !this.isGestorOperacionalLogged;
    },

    canDeleteGroups() {
      return !this.isGestorOperacionalLogged;
    },
  },

  methods: {
    query: function (query) {
      let columns = {
        id: "group_id",
        group_id: "group_id",
        group_nome: "group_nome",
        company_name: "company_name",
        status: "status",
      };

      let filters = "";

      $.each(query, function (index, value) {
        if (value !== null && value !== undefined && value !== "") {
          filters += columns[index] + "=" + value + "&";
        }
      });

      return filters;
    },
  },

  mounted() {
    if (this.isUsuarioPadraoLogged) {
      this.$message("Erro", "Você não tem permissão para acessar esta tela", "error");
      this.$router.push("/");
    }
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>